// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6q-0";
export var startPickingButton = "_6q-1";